import { find, register } from '../../../Javascript/Utils'

const component = el => {
  const componentPrefix = el.dataset.componentPrefix
  const openButtonClass = el.dataset.openButtonClass
  const closeButton = find(`.${componentPrefix}close-overlay`, el)
  const docCheckIframe = find('iframe.dclogin', el)
  const docCheckSmall = 's_red'
  const docCheckMedium = 'm_red'

  if (closeButton) {
    closeButton.addEventListener('click', (event) => {
      event.preventDefault()
      toggleHidden(true)
    })
  }

  Array.from(el.querySelectorAll('a[data-action="close-overlay"]')).forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault()
      toggleHidden(true)
    })
  })

  if (openButtonClass) {
    const openButton = document.getElementsByClassName(openButtonClass)
    if (openButton) {
      Array.from(openButton).forEach((button) => {
        button.addEventListener('click', (event) => {
          console.log('LoginSwitch -> Overlay Script')
          event.preventDefault()
          toggleHidden(false)
          openOverlay(button)
        })
      })
    }
  }

  window.addEventListener('DOMContentLoaded', function () {
    const restrictedOverlayExists = document.getElementsByClassName('medacMoleculeRestrictedcontentoverlay-component')
    if (restrictedOverlayExists && openButtonClass) {
      const button = document.querySelector(`.${openButtonClass}[data-user]`)
      const accessGroup = document.documentElement.dataset.accessGroup
      const whereiam = document.querySelector('html').getAttribute('lang').split('-')[1].toUpperCase()

      if (accessGroup === '2' && (whereiam === 'DE' || whereiam === 'PT')) {
        console.log('access:')
        console.log(accessGroup)

        toggleHidden(false)
        openOverlay(button)
      }
    }
  })

  function openOverlay (button) {
    const whereiam = document.querySelector('html').getAttribute('lang').split('-')[1].toUpperCase()
    let user = ''

    if (button) {
      user = button.dataset.user
    } else {
      user = document.documentElement.dataset.accessGroup === '2' ? 'hcp' : ''
    }

    // console.log(user)

    if (user) {
      el.querySelectorAll('.medacMoleculeLoginoverlay-login-text[data-user]').forEach((el) => {
        el.style.display = 'none'
      })
      document.querySelector('.medacMoleculeLoginoverlay-login-text[data-user="' + user + '"]').style.display = 'block'
    }

    if (user === 'hcp' && (whereiam === 'DE' || whereiam === 'PT')) {
      el.classList.add('docCheckEnable')
    } else if (Object.keys(button.dataset).length) {
      el.classList.remove('docCheckEnable')
      document.querySelector('#submit').dataset.user = user
    }
  }

  const toggleHidden = (hidden) => {
    document.body.classList.toggle('noscroll', hidden)
    el.setAttribute('aria-hidden', hidden)
    el.scrollTop = 0
  }

  if (docCheckIframe) {
    resizeDocCheck()
    window.addEventListener('resize', () => {
      resizeDocCheck()
    })
  }

  function resizeDocCheck () {
    const iframeSrc = docCheckIframe.src
    if (window.matchMedia('(max-width: 575px)').matches) {
      if (iframeSrc.includes(docCheckMedium)) {
        docCheckIframe.src = iframeSrc.replace(docCheckMedium, docCheckSmall)
      }
    } else {
      if (iframeSrc.includes(docCheckSmall)) {
        docCheckIframe.src = iframeSrc.replace(docCheckSmall, docCheckMedium)
      }
    }
  }
}

register('Overlay', component)
